export function getLocation() {
  return window.customLocation || window.location
}
